/* ============================================================
   TIM3L3SS — THE ARCHIVE · interactions
   Clock · sticky header · mobile nav · scroll reveal ·
   drop-index scrollspy · quick-add · toast
   Cart-drawer open/update logic lives in sections/cart-drawer.liquid
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Live clock (Zürich / CET) ---------- */
  function pad(n) { return String(n).padStart(2, "0"); }
  function tick() {
    var now;
    try {
      now = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Zurich" }));
    } catch (e) {
      now = new Date();
    }
    var t = pad(now.getHours()) + ":" + pad(now.getMinutes()) + ":" + pad(now.getSeconds());
    document.querySelectorAll("[data-clock]").forEach(function (el) { el.textContent = t; });
  }

  /* ---------- Sticky header shadow ---------- */
  function initStickyHeader() {
    var header = document.querySelector(".tl-header");
    if (!header) return;
    var onScroll = function () { header.classList.toggle("is-stuck", window.scrollY > 8); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var burger = document.querySelector("[data-burger]");
    var nav = document.querySelector("[data-mobile-nav]");
    if (!burger || !nav) return;
    function close() { burger.classList.remove("is-open"); nav.classList.remove("is-open"); document.body.style.overflow = ""; }
    burger.addEventListener("click", function () {
      var open = burger.classList.toggle("is-open");
      nav.classList.toggle("is-open", open);
      document.body.style.overflow = open ? "hidden" : "";
    });
    nav.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", close); });
    window.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".tl-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); io.unobserve(entry.target); }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Drop-index scrollspy ---------- */
  function initScrollspy() {
    var links = document.querySelectorAll(".tl-index__link");
    var sections = document.querySelectorAll(".tl-drop[id]");
    if (!links.length || !sections.length || !("IntersectionObserver" in window)) return;
    var byId = {};
    links.forEach(function (l) {
      var href = l.getAttribute("href") || "";
      if (href.charAt(0) === "#") byId[href.slice(1)] = l;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          links.forEach(function (l) { l.classList.remove("is-active"); });
          var active = byId[entry.target.id];
          if (active) active.classList.add("is-active");
        }
      });
    }, { rootMargin: "-40% 0px -55% 0px", threshold: 0 });
    sections.forEach(function (s) { io.observe(s); });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "tl-toast";
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add("is-show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-show"); }, 2200);
  }
  window.tlToast = toast;

  /* ---------- Quick add (cards) ---------- */
  function initQuickAdd() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".tl-quickadd");
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute("data-variant-id");
      if (!id) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = label;
          btn.disabled = false;
          if (window.updateCartDrawer) window.updateCartDrawer();
          if (window.openCartDrawer) window.openCartDrawer();
          else toast("Added to cart");
        })
        .catch(function () {
          btn.textContent = label;
          btn.disabled = false;
          toast("Could not add — try the product page");
        });
    });
  }

  /* ---------- Whole product card is clickable (image included) ---------- */
  function initCardClick() {
    document.addEventListener("click", function (e) {
      // Let real interactive elements (quick-add, links, form fields) behave normally.
      if (e.target.closest("a, button, input, label, select, textarea, .tl-quickadd")) return;
      var card = e.target.closest(".tl-card[data-href]");
      if (card) window.location.href = card.getAttribute("data-href");
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initCardClick();
    tick();
    setInterval(tick, 1000);
    initStickyHeader();
    initMobileNav();
    initReveal();
    initScrollspy();
    initQuickAdd();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* ---------- Card slider dots (first two images) ---------- */
document.addEventListener("scroll", function (e) {
  var s = e.target;
  if (!s || !s.classList || !s.classList.contains("tl-card__slides")) return;
  var i = Math.round(s.scrollLeft / s.clientWidth);
  s.parentElement.querySelectorAll(".tl-card__dot").forEach(function (d, k) {
    d.classList.toggle("is-active", k === i);
  });
}, true);
